import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-verify-adhar-card-cell-cell-renderer',
  templateUrl: './verify-adhar-card-cell-renderer.component.html',
  styleUrls: ['./verify-adhar-card-cell-renderer.component.css']
})
export class VerifyAdharCardCellRendererComponent implements OnInit, ICellRendererAngularComp {
  params;
  width = 30;
  title = '';
  icon = 'fa fa-info';
  cssClass = '';
  fontSize = 24;

  isULCVerified: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  agInit(params) {
    this.params = params;
    this.width = this.params.width ? this.params.width : 30;
    this.icon = this.params.icon ? this.params.icon : 'fa fa-info';
    this.cssClass = this.params.cssClass ? this.params.cssClass : '';
    this.title = this.params.title ? this.params.title : '';
    this.fontSize = this.params.fontSize ? this.params.fontSize : 24;

    this.isULCVerified = this.params.data.isULCVerified;
  }

  refresh() {
    return true;
  }

  onClick() {
    this.params.context.componentParent.openAdharCardVerifyModal(this.params.data, this.params.rowIndex);
    // this.params.data[this.params.column.colId] = $event.target.value;
    // if (this.params.forceSelection) {
    //   const forceSelection = this.params.forceSelection($event.target.value);
    //   if (forceSelection) {
    //     this.params.data[forceSelection.field] = forceSelection.value;
    //   }
    // }

    // this.params.onInputTextChange(this.params.rowIndex, this.params.column.colId);
  }

}
